import { useTranslation } from "react-i18next";

export default function InquiryHero() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[50vh] md:min-h-[55vh] w-full flex items-end pb-16 md:pb-20 overflow-hidden bg-deepblack">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant+minimalist+close-up+of+a+luxury+grand+piano+keyboard+and+sheet+music+under+soft+warm+spotlight+deep+black+background+with+subtle+champagne+gold+rim+light+on+ivory+keys+intimate+private+music+studio+atmosphere+cinematic+photography+style+high+contrast+dramatic+shadows+no+text+or+logos"
          alt="Piano keys"
          className="w-full h-full object-cover object-center opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-deepblack/30 via-deepblack/50 to-deepblack" />
      </div>

      <div className="relative z-10 w-full px-6 md:px-12 lg:px-16">
        <span className="inline-block px-4 py-1.5 border border-marble/30 rounded-full text-marble/80 text-xs font-sans tracking-widest uppercase mb-5">
          {t("inquiry.hero.tag")}
        </span>
        <h1 className="text-marble font-serif text-4xl md:text-5xl lg:text-6xl font-light tracking-wide">
          {t("inquiry.hero.title")}
        </h1>
        <p className="mt-4 text-marble/50 text-sm md:text-base font-sans max-w-lg leading-relaxed">
          {t("inquiry.hero.subtitle")}
        </p>
      </div>
    </section>
  );
}